import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { supabase } from '../lib/supabase';

interface PageLoaderProps {
  onComplete: () => void;
}

export default function PageLoader({ onComplete }: PageLoaderProps) {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setLogoUrl('https://wjwcuakqeesxnbjznajh.supabase.co/storage/v1/object/public/images/ibomopen2026.png');

    const timer = setTimeout(() => {
      setVisible(false);
    }, 2200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {visible && (
        <motion.div
          key="page-loader"
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.04 }}
          transition={{ duration: 0.55, ease: 'easeInOut' }}
        >
          <div className="relative flex flex-col items-center gap-10">
            <motion.div
              initial={{ opacity: 0, y: -24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              className="relative"
            >
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt="Logo"
                  className="h-20 w-auto object-contain drop-shadow-2xl"
                />
              ) : (
                <span className="font-display text-3xl font-bold text-white tracking-widest">
                  IBOM OPEN
                </span>
              )}
            </motion.div>

            <div className="relative flex items-center justify-center">
              <GolfBallTrail />
            </div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="text-golf-sand/60 text-xs font-body tracking-[0.3em] uppercase"
            >
              Loading
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function GolfBallTrail() {
  const dots = [0, 1, 2, 3, 4];

  return (
    <div className="flex items-end gap-3 h-8">
      {dots.map((i) => (
        <motion.div
          key={i}
          className="rounded-full bg-golf-orange"
          style={{ width: 10, height: 10 }}
          animate={{
            y: [0, -18, 0],
            opacity: [0.3, 1, 0.3],
            scale: [0.8, 1.2, 0.8],
          }}
          transition={{
            duration: 0.9,
            repeat: Infinity,
            delay: i * 0.13,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}
